import React from 'react';
import PropTypes from 'prop-types';
import NonEmptyArrayField from './NonEmptyArrayField';
import Button from '../Button';
import PhoneInput from '../../FormComponents/PhoneInput';

export default function PhoneArray({
  value, errors, onChange, widthSmall, widthBig, label, customClassName
}) {
  return (
    <NonEmptyArrayField
      value={value}
      defaultValue=''
      errors={errors}
      onChange={onChange}
      renderer={({
        val, getHandler: getH, del, add, idx, length, errors: errs,
      }) => {
        return (
          <div key={idx} className={customClassName}>
            {/* <FormattedField
              style={{ width: ((idx === length - 1) && (length > 1)) ? widthSmall : widthBig }}
              label={label}
              format="(###) ###-####"
              mask="_"
              placeholder={'Phone Number'}
              value={val.value || ''}
              onChange={getH('value')}
              error={errs.value}
            /> */}
            <PhoneInput
              placeholder='Phone Number'
              name="notification_phone"
              value={val.value}
              onChange={getH('value')}
            />
            {length > 1 && (
              <Button
                onClick={(e) => {
                  e.preventDefault();
                  del();
                }}
                style={{
                  padding: '0px 5px',
                  marginLeft: 5,
                  verticalAlign: 'top',
                  height: 28,
                  marginTop: 15,
                }}
              >
                <i className="material-icons">delete</i>
              </Button>
            )}
            {(idx === length - 1) && (
              <Button
                onClick={(e) => {
                  e.preventDefault();
                  add();
                }}
                style={{
                  padding: '0px 5px',
                  marginLeft: 5,
                  verticalAlign: 'top',
                  height: 28,
                  marginTop: 15,
                }}
              >
                <i className="material-icons">add</i>
              </Button>

            )}
          </div>
        );
      }}
    />
  );
}

PhoneArray.propTypes = {
  value: PropTypes.arrayOf(PropTypes.oneOfType([
    PropTypes.shape(),
    PropTypes.string,
  ])),
  onChange: PropTypes.func.isRequired,
  errors: PropTypes.shape(),
  widthSmall: PropTypes.number,
  widthBig: PropTypes.number,
};

PhoneArray.defaultProps = {
  value: [],
  errors: {},
  widthSmall: 100,
  widthBig: 121,
};
